import { render } from "./PastRevenue.vue?vue&type=template&id=eacd3ed6"
import script from "./PastRevenue.vue?vue&type=script&lang=js"
export * from "./PastRevenue.vue?vue&type=script&lang=js"

import exportComponent from "/src/Hikarusa.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__